/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import Button from '../button/button.component';
import { EMPTY_STRING } from '../../../constants/constants';
import './confirmation-popup.style.scss';

/**
 * Class representing confirmation popup component.
 * @extends Component
 * */
@inject('commonStore')
@observer
class ConfirmationPopup extends Component {

  static propTypes = {
    commonStore: PropTypes.shape({
      confirmation: PropTypes.shape({
        message: PropTypes.string,
        onCancel: PropTypes.func,
        onConfirm: PropTypes.func
      })
    }),
  };

  static defaultProps = {
    commonStore: {
      confirmation: {
        message: EMPTY_STRING
      },
    },
  };

  /**
   * Calls the confirmation callback.
   * */
  confirm = () => {
    const { commonStore: { closeConfirmation, confirmation: { onConfirm } } } = this.props;

    onConfirm();
    closeConfirmation();
  };

  /**
   * Calls the cancel callback.
   * */
  cancel = () => {
    const { commonStore: { closeConfirmation, confirmation: { onCancel } } } = this.props;

    if (onCancel) {
      onCancel();
    }
    closeConfirmation();
  };

  render() {
    const { commonStore: { confirmation: { message } } } = this.props;

    if (message) {
      return (
        <div className="confirmation-popup">
          <div className="confirmation-background container" />
          <div className="popup container">
            <div className="message">{message}</div>
            <div className="actions">
              <Button
                buttonClass="btn btn-success btn-block"
                onButtonClick={this.confirm}
                title="Continue"
              />
              <Button
                buttonClass="btn btn-secondary btn-block"
                onButtonClick={this.cancel}
                title="Cancel"
              />
            </div>
          </div>
        </div>
      );
    }

    return null;
  }

}

export default ConfirmationPopup;



// WEBPACK FOOTER //
// ./src/common/components/confirmation-popup/confirmation-popup.component.js